module.exports = __webpack_public_path__ + "img/muchbetter.585b503b.png";